import UploadModalLayout, { UploadModalLayoutProps } from './UploadModalLayout';
export type { UploadModalLayoutProps };
export default UploadModalLayout;
